'use client';
import React from 'react';
import { Button } from '@/components/ui/button';
import { PanelLeft } from 'lucide-react';
import { useSidebar } from './sidebar-context';
import { useIsMobile } from '@/hooks/use-mobile';
import { useCommandTeamDrawerOptional } from './sidebar-context';

interface SidebarToggleProps {
    className?: string;
    variant?: 'default' | 'ghost' | 'outline' | 'secondary' | 'destructive' | 'link';
    size?: 'default' | 'sm' | 'lg' | 'icon';
}

export function SidebarToggle({
    className = '',
    variant = 'ghost',
    size = 'icon',
}: SidebarToggleProps) {
    const { toggleSidebar } = useSidebar();
    const isMobile = useIsMobile();
    const drawer = useCommandTeamDrawerOptional();

    const handleClick = () => {
        if (isMobile && drawer) {
            if (drawer.drawerOpen) drawer.closeDrawer();
            else drawer.openDrawer();
            return;
        }
        toggleSidebar();
    };

    return (
        <Button
            variant={variant}
            size={size}
            onClick={handleClick}
            className={`text-foreground hover:bg-muted ${className}`}
        >
            <PanelLeft className="w-5 h-5" />
        </Button>
    );
}

